import {
  Group,
  Mesh,
  Vector3,
} from 'three';
import { Line2 } from 'three/examples/jsm/lines/Line2';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry';

import type { Store } from 'src/app/store';
import type { Area, Link } from 'src/data';
import { scene } from './scene';
import { drawPoint } from './point';

const yAxis = new Vector3(0, 1, 0);
export const orbitHeight = 171;
const orbits = new Group();
orbits.position.y = orbitHeight;
scene.add(orbits);

const linewidth = 0.002;

const lineMaterial = new LineMaterial({
  color: 0x000000,
  linewidth,
});

const clickMaterial = new LineMaterial({
  linewidth: 16 * linewidth,
});

function getCircleVertices(radius: number, sections: number = 256): number[] {
  const flattenedVertices: number[] = [];

  for (let i = 0; i <= sections; i++) {
    const theta = (i / sections) * Math.PI * 2;
    const point = new Vector3(radius, 0, 0);
    point.applyAxisAngle(yAxis, theta);
    flattenedVertices.push(point.x, point.y, point.z);
  }

  return flattenedVertices;
}

function makeOrbitMesh(radius: number, material: LineMaterial): Mesh {
  const positions = getCircleVertices(radius);
  const geometry = new LineGeometry().setPositions(positions);

  const line = new Line2(geometry, material);
  line.computeLineDistances();
  line.scale.set(1,1,1);
  return line;
}

export function drawOrbit(area: Area, store: Store) {
  // add this orbit to the orbits group
  const orbit = new Group();
  orbits.add(orbit);

  // create lines
  const radius = area.fields.radius['en-US'];
  const visibleOrbitLine = makeOrbitMesh(radius, lineMaterial.clone());
  const clickableOrbitLine = makeOrbitMesh(radius, clickMaterial.clone());
  clickableOrbitLine.visible = false;
  orbit.add(visibleOrbitLine);
  orbit.add(clickableOrbitLine);


  // add all points on this orbit
  if (area.fields.points) {
    const points = area.fields.points['en-US'];
    const doubleLength = points.length * 2;
    points.forEach((pointLink: Link, index: number) => {
      const point1 = drawPoint(pointLink.sys.id, index / doubleLength, radius, store);
      orbit.add(point1);

      const point2 = drawPoint(pointLink.sys.id, (index + points.length) / doubleLength, radius, store);
      orbit.add(point2);
    });
  }
}
